import { FaUser, FaHome } from "react-icons/fa"; // Font Awesome icons
import { MdEmail } from "react-icons/md"; // Material Design icons
import {
  FaRegChartBar,
  FaUniversity,
  FaCalendarAlt,
  FaUsers,
  FaFileAlt,
  FaComments,
  FaShieldAlt,
  FaIdBadge,
  FaDownload,
  FaCertificate,
  FaEnvelope,
  FaHeadset,
  FaBookOpen,
  FaSearch,
} from "react-icons/fa";

export const mentorNavList = [
  {
    id: 1,
    label: "Overview",
    link: "/dashboard/mentor",
    icon: <FaRegChartBar />,
  },
  {
    id: 2,
    label: "Profile",
    link: "/dashboard/mentor/profile",
    icon: <FaUniversity />,
  },
  {
    id: 3,
    label: "Membership",
    link: "/dashboard/mentor/membership",
    icon: <FaIdBadge />,
  },
  {
    id: 4,
    label: "Events & Downloads",
    link: "/dashboard/mentor/events",
    icon: <FaDownload />,
  },
  {
    id: 5,
    label: "Certificates",
    link: "/dashboard/mentor/certificates",
    icon: <FaCertificate />,
  },
  {
    id: 6,
    label: "Messages",
    link: "/dashboard/mentor/messages",
    icon: <FaEnvelope />,
  },
  {
    id: 7,
    label: "Support",
    link: "/dashboard/mentor/support",
    icon: <FaHeadset />,
  },
  {
    id: 8,
    label: "Mentor Tools",
    link: null,
    icon: null,
  },
  {
    id: 9,
    label: "My Engagements",
    link: "/dashboard/mentor/my-engagements",
    icon: <FaUsers />,
  },
  {
    id: 10,
    label: "Availability",
    link: "/dashboard/mentor/availability",
    icon: <FaCalendarAlt />,
  },
];

export const authorNavList = [
  {
    id: 1,
    label: "Overview",
    link: "/dashboard/author",
    icon: <FaRegChartBar />,
  },
  {
    id: 2,
    label: "Profile",
    link: "/dashboard/author/profile",
    icon: <FaUniversity />,
  },
  {
    id: 3,
    label: "Membership",
    link: "/dashboard/author/membership",
    icon: <FaIdBadge />,
  },
  {
    id: 4,
    label: "Events & Downloads",
    link: "/dashboard/author/events",
    icon: <FaDownload />,
  },
  {
    id: 5,
    label: "Certificates",
    link: "/dashboard/author/certificates",
    icon: <FaCertificate />,
  },
  {
    id: 6,
    label: "Messages",
    link: "/dashboard/author/messages",
    icon: <FaEnvelope />,
  },
  {
    id: 7,
    label: "Support",
    link: "/dashboard/author/support",
    icon: <FaHeadset />,
  },
  {
    id: 201,
    label: "Author Tools",
    link: null,
    icon: null,
  },
  {
    id: 202,
    label: "My Publication",
    link: "/dashboard/author/my-publication",
    icon: <FaBookOpen />,
  },
  {
    id: 203,
    label: "Journal Finder",
    link: "/dashboard/author/journal-finder",
    icon: <FaSearch />,
  },
];

export const institutionNavList = [
  {
    id: 1,
    label: "Overview",
    link: "/dashboard/institution",
    icon: <FaRegChartBar />,
  },
  {
    id: 2,
    label: "Institution Profile",
    link: "/dashboard/institution/profile",
    icon: <FaUniversity />,
  },
  {
    id: 3,
    label: "Event Management",
    link: "/dashboard/institution/event-management",
    icon: <FaCalendarAlt />,
  },
  {
    id: 4,
    label: "Linked Members",
    link: "/dashboard/institution/linked-members",
    icon: <FaUsers />,
  },
  {
    id: 5,
    label: "Reports & Certificates",
    link: "/dashboard/institution/reports-certificates",
    icon: <FaFileAlt />,
  },
  {
    id: 6,
    label: "Communications",
    link: "/dashboard/institution/communications",
    icon: <FaComments />,
  },
  {
    id: 7,
    label: "Resources & Compliance",
    link: "/dashboard/institution/resources-compliance",
    icon: <FaShieldAlt />,
  },
];
